import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import { OSM, Vector as VectorSource } from 'ol/source';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import { getArea, getLength } from 'ol/sphere';

export const raster = new TileLayer({
  source: new OSM(),
});

export const source = new VectorSource();

export const vector = new VectorLayer({
  source: source,
  style: new Style({
    fill: new Fill({
      color: 'rgba(255, 255, 255, 0.2)',
    }),
    stroke: new Stroke({
      color: '#ffcc33',
      width: 2,
    }),
    image: new CircleStyle({
      radius: 7,
      fill: new Fill({
        color: '#ffcc33',
      }),
    }),
  }),
});

export const formatArea = function (
  polygon: any,
  fn: (output: string) => void
) {
  const area = getArea(polygon);
  let output;
  if (area > 10000) {
    output = Math.round(area) / 10000 + ' ' + 'га';
  } else {
    output = Math.round(area * 100) / 100 + ' ' + 'кв.м';
  }
  fn(output);
  return output;
};

export const formatLength = function (line: any, fn: (output: string) => void) {
  const length = getLength(line);
  let output;

  if (length > 1000) {
    output = Math.round((length / 1000) * 100) / 100 + ' ' + 'км';
  } else {
    output = Math.round(length * 100) / 100 + ' ' + 'м';
  }
  fn(output);
  return output;
};
